export default __webpack_public_path__ + "static/media/stock.d6696f77.jpg";